import api from '@/services/api'

export default {
    fetchFavourites(params) {
        return api.get(`catalog/favourites/`, {params})
            .then(response => response.data)
    },
    fetchFavoritesList(payload) {
        return api.post(`catalog/favourites/list/`, payload)
            .then(response => response.data)
    },
    postFavourite(payload) {
        return api.post(`catalog/favourites/`, payload)
            .then(response => response.data)
    },
    deleteFavourite(productId) {
        return api.delete(`catalog/favourites/${productId}/`)
            .then(response => response.data)
    }
}